"use client"

import { ErrorState } from "@/components/error-state"
import "./globals.css"

/** 루트 레이아웃까지 실패했을 때의 최후 경계 — html/body를 직접 렌더해야 한다. */
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="ko" suppressHydrationWarning>
      <head>
        <script
          dangerouslySetInnerHTML={{
            __html: `(function(){try{var t=localStorage.getItem('theme');var d=t?t==='dark':matchMedia('(prefers-color-scheme:dark)').matches;if(d)document.documentElement.classList.add('dark');}catch(e){}})();`,
          }}
        />
      </head>
      <body className="min-h-full flex flex-col bg-canvas text-ink antialiased">
        <main className="flex min-h-screen flex-col bg-canvas">
          <div className="kiwoom-strip" />
          <ErrorState
            title="서비스에 문제가 발생했습니다"
            message={error.digest ? `참조: ${error.digest}` : "잠시 후 다시 시도해 주세요."}
            retry={reset}
          />
        </main>
      </body>
    </html>
  )
}
